module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "good-item"
  }, [_c('div', {}, [_c('div', {
    staticClass: "good-img"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openProduct(_vm.msg.id)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.msg.image),
      expression: "msg.image"
    }],
    key: _vm.msg.image,
    attrs: {
      "alt": _vm.msg.storeName
    }
  })])]), _vm._v(" "), _c('h6', {
    staticClass: "good-title",
    domProps: {
      "innerHTML": _vm._s(_vm.msg.storeName)
    }
  }, [_vm._v(_vm._s(_vm.msg.storeName))]), _vm._v(" "), _c('div', {
    staticClass: "good-price pr"
  }, [_c('div', {
    staticClass: "ds pa"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openProduct(_vm.msg.id)
      }
    }
  }, [_c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": "查看详情"
    }
  })], 1), _vm._v(" "), _c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": "加入购物车",
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": function($event) {
        return _vm.addCart(_vm.msg)
      }
    }
  })], 1), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("￥")]), _vm._v(_vm._s(_vm.msg.price) + "\n          "), _c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#999",
      "text-decoration": "line-through",
      "font-weight": "400"
    }
  }, [_vm._v("￥" + _vm._s(_vm.msg.otPrice))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d644bfe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mallGoods.vue
// module id = 300
// module chunks = 3 4 7 13 14